export default {
      id: "i-invest-collect-usage",
      viewBox: "0 0 50 25",
      url: __webpack_public_path__ + "img/sprite.svg#i-invest-collect",
      toString: function () {
        return this.url;
      }
    }